import React from 'react';
import { X, Star, ShoppingCart } from 'lucide-react';
import { useCart } from '../context/CartContext';

const ProductModal = ({ product, onClose }) => {
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    addToCart(product);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl max-w-2xl w-full p-4 md:p-6 relative max-h-[90vh] overflow-y-auto">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 p-2 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <X size={20} />
        </button>

        <div className="flex flex-col md:flex-row gap-4">
          {/* Product Image */}
          <div className="flex items-center justify-center w-32 sm:w-36 md:w-40 h-32 sm:h-36 md:h-40 mx-auto">
            <img
              src={product?.images?.[0]?.url || product.image}
              alt={product.name}
              className="w-full h-full object-contain rounded-lg sm:rounded-xl"
            />
          </div>

          {/* Product Info */}
          <div className="flex-1 flex flex-col">
            <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-1 line-clamp-2">
              {product.name}
            </h2>

            <p className="text-xs sm:text-sm text-gray-500 mb-2 truncate">
              {product.category}
            </p>

            <div className="flex items-center mb-2">
              <Star className="text-yellow-400 fill-yellow-400" size={14} />
              <span className="ml-1 text-xs sm:text-sm text-gray-600">
                {product.rating} ({product.numReviews})
              </span>
            </div>

            <p className="text-sm text-gray-700 mb-2 sm:mb-3 leading-relaxed line-clamp-3">
              {product.description}
            </p>

            {product.vendor && (
              <div className="mb-2 sm:mb-3">
                <span className="text-xs text-gray-500">Vendor:</span>{" "}
                <span className="text-sm font-medium text-gray-800">
                  {product.vendor.name}
                </span>
              </div>
            )}

            <div className="flex items-center justify-between mb-3">
              <span className="text-xl sm:text-2xl font-bold text-purple-600">
                ₹{product.price}
              </span>
              <span
                className={`text-xs px-2 py-1 rounded-full font-medium ${
                  product.stock > 20
                    ? "bg-green-100 text-green-700"
                    : "bg-orange-100 text-orange-700"
                }`}
              >
                {product.stock} in stock
              </span>
            </div>

            <button
              onClick={handleAddToCart}
              disabled={product.stock === 0}
              className="w-full bg-gradient-to-r from-purple-600 to-blue-600 text-white py-2 rounded-lg hover:shadow-md transition-all font-medium flex items-center justify-center gap-2 disabled:opacity-50"
            >
              <ShoppingCart size={16} />
              Add to Cart
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductModal;